import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M6 14a.77.77 0 0 1-.6-.29l-4-5.21a.77.77 0 0 1 0-.91l4-5.23a.75.75 0 0 1 1.2.91L2.94 8l3.66 4.82a.75.75 0 0 1-.14 1A.79.79 0 0 1 6 14ZM10 14a.7.7 0 0 1-.47-.17.75.75 0 0 1-.11-1L13.29 8 9.42 3.29a.76.76 0 0 1 .11-1.06.75.75 0 0 1 1.05.11l4.26 5.23a.77.77 0 0 1 0 .95l-4.26 5.22A.72.72 0 0 1 10 14Z';
const draw24px =
  'M9,18a.75.75,0,0,1-.52-.21L3.06,12.54a.75.75,0,0,1,0-1.08L8.48,6.23a.75.75,0,1,1,1,1.08L4.66,12l4.86,4.69a.75.75,0,0,1,0,1.06A.76.76,0,0,1,9,18Zm6.52-.21,5.42-5.23a.75.75,0,0,0,0-1.08L15.52,6.23a.75.75,0,0,0-1,1.08L19.34,12l-4.86,4.69a.75.75,0,0,0,0,1.06A.76.76,0,0,0,15,18,.73.73,0,0,0,15.52,17.77Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const NavigateIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'navigate'),
) as IconWithRender;

NavigateIcon.displayName = 'NavigateIcon';
NavigateIcon.propTypes = Icon.propTypes;
NavigateIcon.renderIcon = (props) => <NavigateIcon {...props} />;
export default NavigateIcon;
